<template>
  <b-container>
    <Form
      :title="title"
      :description="description"
      :media="media"
      :type="type"
      @loadImage="loadImage"
      @onSubmit="onSubmit"
    />
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {COMMUNITY_DETAIL_REQUEST, COMMUNITY_EDIT, COMMUNITY_TYPE_REQUEST, TAG_REQUEST, UPDATE_PICTURE} from "@/store/constant";
import {getImage} from "@/helpers";
import Form from "@/components/Community/Form";

export default {
  name: 'CommunityEdit',
  components: { Form },
  computed: {
    title: {
      get() {
        return this.community ?this.community.title :null;
      }
    },
    description: {
      get() {
        return this.community ?this.community.description :null;
      }
    },
    media: {
      get: function () {
        if (this.community) {
          if (typeof this.community.media === 'string') {
            return this.community.media;
          }
          else {
            return getImage(this.community);
          }
        }
        return null;
      }
    },
    type: {
      get() {
        return this.community ?this.community.type.id :null
      }
    },
    ...mapGetters(['community'])
  },
  mounted() {
    this.getCommunity();
  },
  methods: {
    onSubmit(data, canvas) {
      let formData = new FormData();
      data['token'] = localStorage.getItem('user-token');
      formData.append("data", JSON.stringify(data));

      if (!canvas) {
        alert('画像を選択してください');
        return;
      }
      canvas.toBlob(blob => {
        formData.append('files.media', blob);
        this.$store.dispatch(COMMUNITY_EDIT, {formData, id: this.$route.params.id})
          .then(() => {
            this.$router.push({ name: 'communities' });
          })
      });
    },
    loadImage(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.$store.commit(UPDATE_PICTURE, e.target.result);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    getCommunity() {
      this.$store.dispatch(COMMUNITY_DETAIL_REQUEST, this.$route.params.id);
    },
    cropperReady() {
      const { width, height } = this.community.media;
      this.$refs.cropper.setCoordinates({
        width,
        height,
      })
    },
    getImage
  }
}
</script>

<style scoped>
.cropper {
  border: solid 1px #EEE;
  height: 300px;
  width: 100%;
}

.upload-btn {
  position: relative;
  top: -1px;
  border-radius: 0;
}

.custom-file {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  opacity: 0;
}
</style>
